import { useMutation } from '@apollo/client';
import { NOTIFY_ME_ON_PRODUCT_BACK_IN_STOCK_V2 } from '../queries';

interface INotifyMe {
  email: string;
  sku: string;
  successCallback: (messageKey: 'notifyMeSuccess') => void; // Use Generic type would be bettet @intl-ts
  errorCallback: (messageKey: 'notifyMeError') => void;
}

export const useNotifyMe = () => {
  const [notifyMeOnProductBackInStockV2, { loading }] = useMutation(
    NOTIFY_ME_ON_PRODUCT_BACK_IN_STOCK_V2,
  );

  const notifyMe = async ({
    email,
    sku,
    successCallback,
    errorCallback,
  }: INotifyMe): Promise<void> => {
    try {
      const { data } = await notifyMeOnProductBackInStockV2({
        variables: {
          email,
          sku,
        },
      });

      if (!data.notifyMeOnProductBackInStockV2) {
        throw new Error('And error occured');
      }

      successCallback && successCallback('notifyMeSuccess');
    } catch (error: any) {
      errorCallback && errorCallback('notifyMeError');
    }
  };

  return { notifyMe, loading };
};
